import styled, { css, keyframes } from 'styled-components'
import theme from '../theme'

type StyledElementProps = {
  width?: number
  height?: number
  variant?: 'gradient' | 'white' | 'transparent'
}

const shimmerAnimation = keyframes`
  0% {
    background-position: -1000px 0;
  }

  100% {
    background-position: 1000px 0;
  }
`

// @TODO: сделать быстрее и производительнее.
const skeletonShimmerCss = css`
position: relative;
overflow: hidden;

&::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 50%;
  width: 500%;
  margin-left: -250%;
  background: linear-gradient(to right, #b0b0b0, white 50%, #b0b0b0);
  background-attachment: fixed;
  background-size: 1000px auto;
  z-index: 1;
  animation: 4s cubic-bezier(0.65, 0, 0.35, 1) ${shimmerAnimation} infinite;
`

export const Container = styled.div``

export const Element = styled.div<StyledElementProps>`
  background-color: ${theme.palette.black(94)};
  border-radius: 5px;

  ${({ width, height }) => css`
    width: ${width ? `${width}px` : 'auto'};
    height: ${height ? `${height}px` : 'auto'};
  `}

  ${({ variant = 'gradient' }) => {
    switch (variant) {
      case 'gradient':
        return skeletonShimmerCss
      case 'transparent':
      case 'white':
        return css`
          background: ${variant};
        `
      default:
        return css``
    }
  }}
`
